"use strict";exports.default=()=>"Empty";